import { Alerts } from "src/app/common/enums/Tasks.enum";
import { ViewType } from "src/app/common/enums/view-type.enum";

export const TasksConfig = [
  {
    name: Alerts.OverDueDocuments,
    colour: "#FBEAEA",
    imageSrc: "/assets/home/notification-important.svg",
    alertVisibleViews: [ViewType.DOR_VIEW, ViewType.THERAPIST_VIEW]
  },
  {
    name: Alerts.MissedVisits,
    colour: "#F7F9FC",
    imageSrc: "/assets/home/error-outline.svg",
    alertVisibleViews: [ViewType.DOR_VIEW, ViewType.THERAPIST_VIEW]
  },
  {
    name: Alerts.MissedMDSignatures,
    colour: "#FFF7D6",
    imageSrc: "/assets/home/warning-solid.svg",
    alertVisibleViews: [ViewType.DOR_VIEW, ViewType.THERAPIST_VIEW]
  },
  {
    name: Alerts.MissedTimeSheets,
    colour: "#FCE6FC",
    imageSrc: "/assets/home/writing.svg",
    alertVisibleViews: [ViewType.DOR_VIEW, ViewType.THERAPIST_VIEW]
  },
  {
    name: Alerts.NoTherapyThreeDays,
    colour: "rgba(224, 17, 17, 0.34)",
    imageSrc: "/assets/home/alert-round-solid.svg",
    alertVisibleViews: [ViewType.DOR_VIEW]
  },
  {
    name: Alerts.TherapyScreenOrReferral,
    colour: "rgba(52, 167, 31, 0.19)",
    imageSrc: "/assets/home/referral.svg",
    alertVisibleViews: [ViewType.DOR_VIEW, ViewType.THERAPIST_VIEW]
  },
  {
    name: Alerts.Discrepancies,
    colour: "rgba(224, 17, 17, 0.34)",
    imageSrc: "/assets/home/alert-round-solid.svg",
    alertVisibleViews: [ViewType.DOR_VIEW]
  },
  {
    name: Alerts.TimeCardImportFailures,
    colour: "#E6F0FA",
    imageSrc: "/assets/home/warning-solid.svg",
    alertVisibleViews: [ViewType.DOR_VIEW],
    hideWhenZero: true
  },
];
